/**
 * Per-environment auth-server addressing (ADR-017). The SPA is served from a known set of
 * hostnames (dev/prod SWA custom domains, localhost during development), and each maps to its
 * environment's OpenID Provider. v1 keeps this as a hostname map — the seam to replace with
 * build-time configuration if the mapping ever stops being static. The client id matches the
 * auth-server's registered SPA client (`spa_client_id` in its tfvars).
 */
export interface AuthConfig {
  /** The OpenID Provider's issuer URL (no trailing slash). */
  readonly issuer: string;
  /** The SPA's registered public client id. */
  readonly clientId: string;
}

const CLIENT_ID = 'test-merchant-spa';

export function authConfigFor(hostname: string): AuthConfig {
  const issuer =
    hostname === 'test.tilgong.com'
      ? 'https://auth.tilgong.com'
      : hostname === 'localhost' || hostname === '127.0.0.1'
        ? 'http://localhost:7071'
        : 'https://auth.dev.tilgong.com';
  return { issuer, clientId: CLIENT_ID };
}
